import React from 'react'
import Navbar from '../features/Navbar'
import Footer from '../components/Footer'

const About = () => {
  return (
    <div className='w-screen'>
      <div className='sticky top-0 z-50'>
        <Navbar />
      </div>
      <section>
        <section className="relative h-[200px]">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1525431836161-e40d6846e656?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c3BsYXNofGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60')` }}></div>
          <div className="absolute inset-0 bg-opacity-60 bg-black"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white">
              <h1 className="text-4xl font-bold mb-6">About Us</h1>
            </div>
          </div>
        </section>
        <section className="bg-gray-100 py-8 px-10">
          <div className="container mx-auto flex flex-col md:flex-row justify-center space-y-6 md:space-y-0 md:space-x-6">
            <div className="">
              <img className="rounded-lg w-[500px] h-[380px]" src="https://images.unsplash.com/photo-1525431836161-e40d6846e656?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c3BsYXNofGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60g" alt="About" />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold mb-4">CAC City Of God</h2>
              <p className="text-lg mb-6">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac mi condimentum, tristique nulla sit amet, vehicula justo. Nulla a mauris ac est rutrum tincidunt. Mauris nec efficitur neque.</p>
              <p className="text-lg mb-6">Duis eu justo non velit vulputate elementum sed ut est. Pellentesque ac iaculis urna. Nunc vel mauris nec nisi dignissim rutrum. Cras aliquam efficitur ipsum ut tempus.</p>
              <p className="text-lg mb-6">Duis eu justo non velit vulputate elementum sed ut est. Pellentesque ac iaculis urna. Nunc vel mauris nec nisi dignissim rutrum. Cras aliquam efficitur ipsum ut tempus.</p>
              <p className="text-lg mb-6">Duis eu justo non velit vulputate elementum sed ut est. Pellentesque ac iaculis urna. Nunc vel mauris nec nisi dignissim rutrum. Cras aliquam efficitur ipsum ut tempus.</p>
            </div>
          </div>
        </section>
      </section>
      <Footer/>
    </div>
  )
}

export default About